<template>
  <b-modal ref="mdlConfigurazioneMagazzinoCategoriaArticoli" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <label class="sa-label-data">Codice Azienda</label>
        <b-form-select v-model="localData.codiceAzienda">
          <template #first>
            <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
          </template>
          <b-form-select-option v-for="item in strutturaOptions" :key="item.id" :value="item.codiceStruttura"
            ><span>{{ `${item.denominazione} (${item.codiceStruttura}) ` }}</span></b-form-select-option
          >
        </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <label class="sa-label-data">Categoria</label>
        <span v-if="isReadOnly"> {{ localData.categoria }}</span>
        <b-form-input v-else v-model="localData.categoria"></b-form-input>
      </b-col>

      <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <label class="sa-label-data">Note</label>
        <span v-if="isReadOnly">{{ localData.note }}</span>
        <b-textarea v-else v-model="localData.note" max-rows="10" rows="7"></b-textarea>
      </b-col>
    </b-row>
    <template #modal-footer>
      <b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
      <b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaCategoriaArticolo">Salva</b-button>
      <b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
    </template>
    <modal-error ref="cmpModalError"></modal-error>
  </b-modal>
</template>
<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoMixins from "../mixins/MagazzinoMixins";
export default {
  name: "ConfigurazioniMagazzinoArticoliCategoriaModalEditComponent",
  mixins: [UtilityMixin, StruttureMixin, MagazzinoMixins],
  components: { ModalError },
  data() {
    return {
      title: null,
      pathResource: "/magazzinoarticolicategorie",
      isReadOnly: false,
      localData: {
        id: null,
        codiceAzienda: null,
        categoria: null,
        note: null,
      },
    };
  },
  mounted() {
    this.struttureLoadData();
  },
  props: {
    jsonData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  methods: {
    show(jsonData, isReadOnly) {
      let me = this;
      me.localData = jsonData;
      me.isReadOnly = isReadOnly;
      if (me.jsonData) {
        this.localData.codiceAzienda = me.jsonData.codiceAzienda;
      }
      if (isReadOnly) {
        me.title = "Visualizzazione Categoria";
      } else {
        me.title = !jsonData.id ? "Nuova Categoria" : "Aggiorna Categoria";
      }
      me.$refs.mdlConfigurazioneMagazzinoCategoriaArticoli.show();
    },
    onCloseModal() {
      let me = this;
      me.localData = {
        id: null,
        codiceAzienda: null,
        categoria: null,
        note: null,
      };
      me.$emit("onCloseModal");
      me.$refs.mdlConfigurazioneMagazzinoCategoriaArticoli.hide();
    },
    onClickSalvaCategoriaArticolo() {
      let me = this;
      UtilityMixin.methods.saveResource(me.pathResource, me.localData, me.salvaCategoriaArticoloSuccess, me.salvaCategoriaArticoloError);
    },
    salvaCategoriaArticoloSuccess(response) {
      let me = this;
      me.$emit("saveCategoriaArticolo", response);
      me.$refs.mdlConfigurazioneMagazzinoCategoriaArticoli.hide();
      me.$bvToast.toast("Salvataggio avvenuto con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    salvaCategoriaArticoloError(error) {
      let me = this;
      me.$emit("saveCategoriaArticolo", error);
      me.$refs.cmpModalError.show(error.response.data.messaggio);
    },
    onDeleteCategoriaArticolo(item) {
      let me = this;
      me.$bvModal
        .msgBoxConfirm("Sei sicuro di eliminare questa configurazione?", {
          title: "Eliminazione Categoria",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            me.deleteCategoriaArticolo(item.id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteCategoriaArticolo(id) {
      let me = this;
      UtilityMixin.methods.deleteResource(me.pathResourceCategoriaArticoli + "/" + id, null, me.deleteCategoriaArticoloSuccess, me.deleteCategoriaArticoloError);
    },
    deleteCategoriaArticoloSuccess(response) {
      let me = this;
      me.$emit("categoriaArticoloDelete", response);
      me.$bvToast.toast("Eliminazione avvenuta con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    deleteCategoriaArticoloError(response) {
      let me = this;
      me.$emit("categoriaArticoloDelete", response);
      me.$bvToast.toast("Errore durante l'eliminazione", {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },
  },
};
</script>
